/**
 * A singleton for configuration.
 *
 * This is quick and dirty. We should replace with something that does dup checking, deep-key resolution, etc.
 * similar to "configuration" from costar.web.infrastructure
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
;
var configs = {};
var _reserved = Symbol();
var _promises = Symbol();
var _events = Symbol();
var Config = (function () {
    function Config() {
        this[_reserved] = Object.keys(Config.prototype);
        this[_promises] = new Map();
        this[_events] = {};
    }
    Config.prototype.set = function (key, value) {
        if (this[_reserved].indexOf(key) >= 0) {
            throw new Error("Reserved name \"" + key + "\" is not allowed as a Config key");
        }
        this[key] = value;
        var promises = this[_promises];
        var val = promises.get(key);
        if (val) {
            val.resolve(value);
            promises.delete(key);
        }
        if (this[_events].onSet) {
            this[_events].onSet(key, value);
        }
    };
    Config.prototype.get = function (key) {
        if (!this.has(key)) {
            throw new Error("No configuration property " + key);
        }
        return this[key];
    };
    /**
     * Remove an entry from configuration
     *
     * @param {string} key
     */
    Config.prototype.delete = function (key) {
        if (!this.has(key)) {
            return false;
        }
        else {
            delete this[key];
            return true;
        }
    };
    /**
     * Test if a key exists in configuration
     *
     * @param {string} key
     * @returns {boolean}
     */
    Config.prototype.has = function (key) {
        return this.hasOwnProperty(key);
    };
    /**
     * Clear ALL config data
     *
     */
    Config.prototype.clear = function () {
        var _this = this;
        Object.keys(this).forEach(function (key) { _this.delete(key); });
    };
    Config.prototype.getAsync = function (key, timeout) {
        if (timeout === void 0) { timeout = 0; }
        return this.getMultipleAsync([key], timeout).then(function (_a) {
            var arr = _a[0];
            return arr;
        });
    };
    Config.prototype.getMultipleAsync = function (keys, timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 0; }
        var promises = this[_promises];
        var allPromises = Promise.all(keys.map(function (key) {
            if (!promises.has(key)) {
                // Force Typescript to accept that this empty object
                // is of the type that we are currently constructing it to be
                var data = {};
                // all three members of PromiseCapture are initalized here synchronously
                data.promise = new Promise(function (resolve, reject) {
                    data.resolve = resolve;
                    data.reject = reject;
                    if (_this.has(key)) {
                        resolve(_this.get(key));
                    }
                });
                data.name = key;
                promises.set(key, data);
            }
            return promises.get(key).promise;
        }));
        if (timeout > 0) {
            setTimeout(function () {
                var names = Array.from(promises.values()).map(function (e) { return e.name; }).join(', ');
                var firstReject = Array.from(promises.values())[0].reject;
                firstReject("The configuration item(s) \"" + names + "\"  never assigned within the timeout period.");
            }, timeout);
        }
        return allPromises;
    };
    /**
     * Bind a callback when any key is set.
     *
     * @param {(key: string, value: string)=> void} cb
     */
    Config.prototype.onSet = function (cb) {
        // TODO - use real event emitter for this? too weighty?
        this[_events].onSet = cb;
    };
    return Config;
}());
exports.Config = Config;
function getConfig(scope) {
    if (!configs[scope]) {
        configs[scope] = new Config();
    }
    return configs[scope];
}
exports.getConfig = getConfig;
var defaultConfig = getConfig("default");
exports.default = defaultConfig;
//# sourceMappingURL=index.js.map